<div *ngFor="let msg of messages" [ngClass]="{'success': isSuccess, 'error': !isSuccess, 'show': showMessage}">
  <span>{{ msg }}</span>
  <button (click)="closeMessage()"><i class="bi-x"></i></button>
</div>
